import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { PRODUCT_NAME } from '../../data/salesContent';
export function FinalCtaSection() {
  return <section className="border-t border-zinc-800 bg-zinc-900 px-5 py-20 md:py-28" data-id="element-109" data-mp="2ik130jqmf6x9">
      <div className="mx-auto max-w-3xl text-center" data-id="element-110" data-mp="2dibmwpojk32b">
        <ProductImage className="mx-auto w-full max-w-xl" data-id="element-111" data-mp="2rj4mhotp9oca" />
        <p className="font-display mt-12 text-xl font-bold uppercase tracking-[0.15em] text-accent md:text-2xl" data-id="element-112" data-mp="2rhjsq1f7m9fh">{PRODUCT_NAME}</p>
        <h2 className="font-display mt-5 text-5xl font-black uppercase leading-[1] text-zinc-50 md:text-7xl" data-id="element-113" data-mp="2mi73ja0v8q9q">
          Dejá de armar tus capacitaciones de detailing <span className="text-accent" data-id="element-114" data-mp="2wb5ugyju4swi">desde cero.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-zinc-400 md:text-xl" data-id="element-115" data-mp="3a948g2u8unbh">Tené en un solo lugar:</p>
        <p className="mx-auto mt-2 max-w-2xl text-sm font-bold uppercase tracking-widest text-zinc-50 md:text-base" data-id="element-116" data-mp="36922hhhh77qe">
          Contenidos + clases + prácticas + evaluaciones + herramientas
        </p>
        <div className="mt-10 space-y-1" data-id="element-117" data-mp="2637pdiyvufev">
          <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-zinc-50 md:text-3xl" data-id="element-118" data-mp="263zi8m13hz1g">6 volúmenes + 5 bonos</p>
          <p className="text-sm font-bold uppercase tracking-widest text-gold md:text-base" data-id="element-119" data-mp="2g0vkia0ehoxk">20 clases + 50 escenarios + 150 preguntas</p>
        </div>
        <div className="mt-6" data-id="element-120" data-mp="2kxchltpkvdms">
          <PriceBlock lead="Hoy por" data-id="element-121" data-mp="2p0sbwje6d1wb" />
        </div>
        <div className="mt-10" data-id="element-122" data-mp="2ozh9oo0do27b">
          <CtaButton data-id="element-123" data-mp="2trqujpmmyc2q">Quiero acceder al sistema completo</CtaButton>
        </div>
        <p className="font-display mt-8 text-2xl font-extrabold uppercase text-zinc-50 md:text-3xl" data-id="element-124" data-mp="2tttv33leznlp">
          Menos tiempo preparando. <span className="text-accent" data-id="element-125" data-mp="33pwsjw5bmy2b">Más tiempo enseñando.</span>
        </p>
      </div>
    </section>;
}